module.exports = __webpack_public_path__ + "components/flag/static/square/zm-f0645a0cb30f63a3c4d458ab2adb8d75.svg";